var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Oauth1")]),_vm._v(" Not complete yet. This is mostly for Twitter since they don't support oauth2 yet... ")])}]

export { render, staticRenderFns }